export default "__VITE_ASSET__e7ea988e__"